import { GENDER_TYPES } from "./index";

export const customerRadioButtonFields = [
  GENDER_TYPES.MALE,
  GENDER_TYPES.FEMALE,
];
